import { Action, createReducer, on } from '@ngrx/store';
import { fromStaticDataBusinessUserStatusActions } from '../actions';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IStaticDataResponse } from '../models/static-data.model';

export const businessUserStatusFeatureKey = 'businessUserStatus';

export interface BusinessUserStatusState {
  businessUserStatusResponse: IStaticDataResponse[];
  businessUserStatusFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: BusinessUserStatusState = {
  businessUserStatusFailure: undefined,
  businessUserStatusResponse: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromStaticDataBusinessUserStatusActions.loadBusinessUserStatuses, (state, action) => ({
    ...state,
    loaded: true
  })),

  on(fromStaticDataBusinessUserStatusActions.loadBusinessUserStatusesSuccess, (state, action) => ({
    ...state,
    businessUserStatusResponse: action.response
  })),

  on(fromStaticDataBusinessUserStatusActions.loadBusinessUserStatusesFailure, (state, action) => ({
    ...state,
    businessUserStatusFailure: action.error
  }))
);

export const getBusinessUserStatusResponse = (state: BusinessUserStatusState) => state.businessUserStatusResponse;
export const getBusinessUserStatusFailure = (state: BusinessUserStatusState) => state.businessUserStatusFailure;
export const getBusinessUserStatusIsLoaded = (state: BusinessUserStatusState) => state.loaded;
